import { ENV_PARAMS } from './evnParams'

export enum EnableTrade {
  Disabled = 0, // 系统可以交易
  Enabled = 1 // 系统不可以交易
}

export const DEFAULT_FROM_CHAIN_ID = ENV_PARAMS.MODE === 'dev' ? 97 : 56

export const DEFAULT_TO_CHAIN_ID = ENV_PARAMS.MODE === 'dev' ? 20028 : 20028
